export const ERROR_MESSAGES = {
  RATE_LIMIT: 'Looks like you have exceeded the number of permitted requests. Please try again after some time.',
  UNKNOWN: 'Looks like we encountered a problem. Please try again after some time.',
  INVALID_EMAIL: 'Please enter a valid email address',
};
